"use client";

import Link from "next/link";
import { useSession } from "@/lib/auth-client";
import styles from "./page.module.css";

/**
 * Client-side for the session read, which decides whether the primary call to
 * action is "create an account" or "open your account". The placeholder keeps
 * the buttons' space reserved while that first check is in flight, so the
 * layout does not jump on load.
 */
export default function Home() {
  const { data: session, isPending } = useSession();

  return (
    <div className={styles.page}>
      <main className={styles.main}>
        <div className={styles.intro}>
          <h1 className={styles.title}>SiteOfPurple</h1>
          <p className={styles.tagline}>
            A small, self-hosted corner of the internet. Make an account and
            take it for a spin.
          </p>
        </div>

        <div className={styles.ctas} aria-busy={isPending}>
          {isPending ? (
            <span className={styles.ctaPlaceholder} aria-hidden="true" />
          ) : session ? (
            <>
              <Link className={styles.primary} href="/guess">
                Play the song guesser
              </Link>
              <Link className={styles.secondary} href="/account">
                Open your account
              </Link>
              <p className={styles.signedIn}>
                Signed in as {session.user.name || session.user.email}
              </p>
            </>
          ) : (
            <>
              <Link className={styles.primary} href="/sign-up">
                Create account
              </Link>
              <Link className={styles.secondary} href="/sign-in">
                Log in
              </Link>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
